export function ensureValidDate(dateInput: Date | string | undefined | null): Date | null {
  if (dateInput === undefined || dateInput === null) {
    return null;
  }

  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date;
}
